<template>
    <TooltipComp
        :text="text"
        class="d-flex flex-row align-items-center gap-1"
    >
        <IconComp
            :icon="icon"
            v-if="icon"
        ></IconComp>
        <DisplayTimespan
            :value="value"
            :format="format"
            :monospace="monospace"
            :null-value-as-timestamp="nullValueAsTimestamp"
        />
    </TooltipComp>
</template>
<script setup lang="ts">
import { DisplayTimespan, TooltipComp, IconComp } from '@/components';
import type { StationDeviceStatus } from '@/objects/generated';
import type { TimeSpan } from '@/objects/TimeSpan';
import type { TimeType } from '@/utilities/dateutils';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        value: TimeSpan | null;

        /**
         * The format to use for the time
         * @default TIMEMS3
         */
        format?: TimeType;

        /**
         * If the text should be monospace
         * @default true
         */
        monospace?: boolean;

        /**
         * If set, then the value will be shown as a timestamp 00:00:00.000
         */
        nullValueAsTimestamp?: boolean;

        row?: StationDeviceStatus;
    }>(),
    {
        format: 'TIMEMS3',
        nullValueAsTimestamp: false,
        monospace: true,
    },
);

// information about the offset type to show in the tooltip
const text = computed<string>(() => {
    if (props.row == null) {
        return '';
    }

    if (props.row?.DeviceStatus?.OffsetType == 'MiniTrackDelayed') {
        return 'timeoffsettype.minitrackdelayed';
    }
    if (props.row?.DeviceStatus?.OffsetType == 'Status') {
        return 'timeoffsettype.status';
    }
    if (props.row?.DeviceStatus?.OffsetType == 'Time') {
        return 'timeoffsettype.time';
    }

    return '';
});

// icon to show based on the offset type
const icon = computed<string | null>(() => {
    if (props.row == null) {
        return null;
    }

    if (props.row?.DeviceStatus?.OffsetType == 'MiniTrackDelayed') {
        return 'fa-square-m';
    }
    if (props.row?.DeviceStatus?.OffsetType == 'Status') {
        return 'fa-square-s';
    }
    if (props.row?.DeviceStatus?.OffsetType == 'Time') {
        return 'fa-square-t';
    }

    return null;
});
</script>
